module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "生成礼品卡",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片主题"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.dataForm.topicName),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "topicName", $$v)
      },
      expression: "dataForm.topicName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生成数量",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "min": 1,
      "placeholder": "请输入生成数量"
    },
    model: {
      value: (_vm.dataForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "quantity", $$v)
      },
      expression: "dataForm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.dataForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v)
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-popconfirm', {
    attrs: {
      "title": "确认生成礼品卡吗？",
      "confirmButtonText": "确定",
      "cancelButtonText": "取消",
      "icon": "el-icon-question"
    },
    on: {
      "onConfirm": function($event) {
        return _vm.dataFormSubmit()
      }
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    slot: "reference"
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-23323d2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/giftCard/components/generateCard.vue
// module id = 1614
// module chunks = 0